import * as XLSX from 'xlsx-js-style';

/**
 * Get all rows keys of the first column.
 *
 * @param sheet XLSX Sheet object.
 * @returns list of all rows keys of the first column.
 */
export const getRowsKeys = (sheet: XLSX.WorkSheet) => {
  const rowKeys = Object.keys(sheet).filter((key) => key.match(/[A][0-9]+$/));
  return rowKeys;
};

/**
 * Get all used columns keys.
 *
 * @param sheet XLSX Sheet object.
 * @returns list of all used columns keys.
 */
export const getColumnsKeys = (sheet: XLSX.WorkSheet) => {
  const columnKeys = Object.keys(sheet).filter((key) => key.match(/[A-Z]+[1]$/));
  return columnKeys;
};
